import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { StyledCheckbox } from './elements';

var CheckboxBullet = function CheckboxBullet(_ref) {
  var isChecked = _ref.isChecked;
  return /*#__PURE__*/React.createElement(StyledCheckbox, {
    className: isChecked ? 'checked' : '',
    "data-testid": "styled-checkBox"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check-mark",
    color: "currentColor",
    width: "10px",
    height: "10px"
  }));
};

CheckboxBullet.propTypes = {
  isChecked: PropTypes.bool.isRequired
};
export default CheckboxBullet;